
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 68.28 12.84"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"68.28","height":"12.84","rx":"6.42","data-name":"-e-iconTimerStyle3"}})])
          )
        }
      }
    